
// to be removed
const namedColors = {
  BLACK: '#000000',
  WHITE: '#FFFFFF',
  ERROR: '#ff0000',
}

export const themeColors = {
  ...namedColors,
  black: '#000000',
  white: '#ffffff',
  green: '#03aa32',
  grayDark: '#828282',
  grayLight: '#D7DBDD',
  bodyGray: '#FBFBFB',
  textGray: '#696969',
  iconGray: '#bbbbbb',
  blueEval: '#4C9EFD',
  blueFacm: '#005EC9',
  blueCommon: '#0076FC',
  warningYellow: '#fcab19',
  warningOrange: '#fc660d',
  purple: '#833E94',
  red: '#EB5757',
}

const animDuration = 200

export const theme = {
  colors: themeColors,
  spacing: {
    sidebarWidth: 313,
  },
  typography: {
    body: '16px',
    label: '18px',
    menu: '20px',
    h3: '20px',
    h2: '30px',
    h1: '35px',
  },
  timings: {
    interaction: `${animDuration}ms`,
  },
  transition: (duration = animDuration) => `transition: ${duration}ms`,
}
